<template>
  <v-card>
    <v-card-text>
      <template v-if="peer === null || peer.destroyed">
        <v-text-field v-model="peerId" label="Peer id" outlined></v-text-field>
        <v-btn @click="create" class="mb-8">
          Create
        </v-btn>
      </template>
      <div v-if="peer">
        ID: {{ peer.id }}<br />
        Uptime: {{ seconds }}<br />
        Disconnected: {{ peer.disconnected }}<br />
        Destroyed: {{ peer.destroyed }}<br />
        <v-btn @click="disconnect">Disconnect</v-btn>
        <v-btn @click="destroy">Destroy</v-btn>
        <v-text-field
          v-model="destPeerId"
          label="Destination peer id"
          outlined
          class="mt-8"
        ></v-text-field>
        <v-btn
          @click="connect"
          :disabled="
            peer.id === undefined || peer.destroyed || destPeerId.length === 0
          "
        >
          Connect
        </v-btn>
        <v-text-field v-model="message" label="Message" outlined></v-text-field>
        <v-btn @click="send" :disabled="message.trim().length === 0">
          Send
        </v-btn>
      </div>
      <v-textarea
        v-model="logsAsLines"
        label="Logs"
        readonly
        outlined
        class="mt-8"
      ></v-textarea>
      Outgoing connections<br />
      <DataConnection
        v-for="(connection, index) in outgoingConnections"
        :key="'outgoing-' + index"
        :connection="connection"
      ></DataConnection>
      Incoming connections<br />
      <DataConnection
        v-for="(connection, index) in incomingConnections"
        :key="'incoming-' + index"
        :connection="connection"
      ></DataConnection>
    </v-card-text>
  </v-card>
</template>

<script>
import { PeerFactory } from '../libs/server/NewServer';
import DataConnection from './DataConnection';
import ConnectionList from '../libs/ConnectionList';

export default {
  name: 'Client',
  components: { DataConnection },
  data() {
    return {
      seconds: 0,
      message: '',
      peerId: '',
      destPeerId: '',
      peer: null,
      logs: [],
      intervalId: null,
      outgoingConnectionList: null,
      incomingConnectionList: null,
      outgoingConnections: [],
      incomingConnections: [],
    };
  },
  computed: {
    logsAsLines() {
      return this.logs.join('\n');
    },
  },
  mounted() {
    this.outgoingConnectionList = new ConnectionList(true);
    this.incomingConnectionList = new ConnectionList(true);
    this.outgoingConnections = this.outgoingConnectionList.connections;
    this.incomingConnections = this.incomingConnectionList.connections;
  },
  beforeDestroy() {
    if (this.peer) {
      this.peer.disconnect();
      this.peer.destroy();
    }
    this.outgoingConnectionList.empty();
    this.incomingConnectionList.empty();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    create() {
      this.seconds = 0;
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.peer = PeerFactory.instance.create(
        this.peerId.trim() === '' ? null : this.peerId.trim()
      );
      this.peer.on('open', (id) => {
        this.logs.push('Open: ' + id);
      });
      this.peer.on('connection', (connection) => {
        if (this.incomingConnectionList.has(connection)) {
          connection.close();
          return;
        }

        this.logs.push('New connection', connection.peer);
        this.incomingConnectionList.add(connection);
      });
      this.peer.on('disconnected', () => {
        this.seconds = 0;
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
        this.logs.push('Disconnected');
      });
      this.peer.on('close', () => {
        this.logs.push('Closed');
      });
      this.peer.on('error', (error) => {
        this.logs.push(error.toString());
      });

      this.intervalId = setInterval(() => {
        this.seconds++;

        if (this.seconds % 10 === 0) {
          // this.incomingConnectionList.connections.map((connection) => {
          //   connection.send('Seconds: ' + this.seconds);
          // });
        }
      }, 1000);
    },
    connect() {
      this.outgoingConnectionList.add(
        this.peer.connect(this.destPeerId, { reliable: true })
      );
    },
    disconnect() {
      this.peer.disconnect();
    },
    destroy() {
      this.peer.destroy();
    },
    send() {
      this.outgoingConnectionList.connections.map((connection) =>
        connection.send(this.message)
      );
      this.message = '';
    },
  },
};
</script>

<style scoped></style>
